<template>
  <modal
    name="send-validation-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @before-open="getData"
    @closed="closeModal()"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Send Validation</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group modified-toggle-switch">
            <div class="d-flex align-items-center flex-wrap mb-2">
              <p class="txt--xs txt--off-white">Department (required)</p>

              <!-- <app-toggle
                :checked="unlimited_validaiton"
                :label="'All Properties'"
              >
              </app-toggle> -->
            </div>
          </div>
          <multiselect
            v-model="selected_department"
            :options="departments"
            class="multi-select-input"
            :multiple="false"
            placeholder="Select Department"
            track-by="department_name"
            label="department_name"
          >
          </multiselect>
          <div class="form-group modified-toggle-switch">
            <div class="d-flex align-items-center flex-wrap my-3">
              <p class="txt--xs txt--off-white">Validation Name(required)</p>

              <!-- <app-toggle
                :checked="unlimited_validaiton"
                :label="'All Properties'"
              >
              </app-toggle> -->
            </div>
          </div>
          <multiselect
            v-model="selected_validation"
            class="multi-select-input"
            :options="validations"
            :multiple="false"
            placeholder="Select Validation"
            track-by="name"
            label="name"
          >
          </multiselect>
          <div class="form-group mt-3">
            <label for="InputText" class="quantity d-block">Quantity</label>
            <input
              v-model="quantity"
              type="text"
              class="textInputField py-3"
              id="InputText"
              aria-describedby="emailHelp"
              placeholder="Enter #"
              style="width: 88px"
            />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center flex-wrap mt-4">

        <ButtonWithSpinner class="button button--primary button--sm mr-3" @click="saveValidation()"
          :disabled="create_button.disabled"
          :loading="create_button.loading"
          :success="create_button.success"  
        >
          Save
        </ButtonWithSpinner>
        
        <button
          type="button"
          class="button button--outline button--sm"
          @click="closeModal()"
        >
          Cancel
        </button>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
import ButtonWithSpinner from "@/components/Button";
// import Toggle from "@/components/toggle";
export default {
  name: "SendValidation",
  components: {
    // AppToggle: Toggle,
    ButtonWithSpinner,
  },
  data() {
    return {
      departments: [],
      selected_department: null,
      validations: [],
      selected_validation: null,
      quantity: null,
      create_button: {
        disabled: false,
        loading: false,
        success: false,
      },
      management_list_refresh_status: false,
    };
  },

  created() {
   /*  this.getValidationsList();
    this.getDepartmentsList(); */
  },
  methods: {
    getData(){
     // this.management_list_refresh_status=false;
      this.getValidationsList();
      this.getDepartmentsList();
    },
    closeModal() {
  /*    alert(this.management_list_refresh_status);
      if(this.management_list_refresh_status==true)
      { */
        this.$emit('update_validation_management_list');
      //}
      this.reset();
      this.$modal.hide("send-validation-modal");
     
      
    },
    reset(){   
      this.quantity=null;
      this.departments=[];
      this.selected_department= null;
      this.validations= [];
      this.selected_validation=null;
      this.create_button.disabled =false;
      this.create_button.loading  =false;
      this.create_button.success =false;     
    },
    getValidationsList()
    {
      this.axios
        .post(window.hostname + "/api/auth/validation/getValidationList",
        {
            all: true,
            device_type:  1,
            status:1,
        })
        .then((res) => {
            this.validations = res.data.data.validation_list;
        })
        .catch((err) => {
        });
    },
    getDepartmentsList()
    {
      this.axios
        .post(window.hostname + "/api/auth/departments/get-departments-list",
          {
            all: true,
            device_type:  1,
            status:1,
          }
        )
        .then((res) => {
          this.departments = res.data.data;
        })
        .catch((err) => {
        });
    },
    isInt(value) {
      var x = parseFloat(value);
      return !isNaN(value) && (x | 0) === x;
    },
    saveValidation()
    {    

      if(this.selected_department == null){
        this.$toasted.show('Please select a department!', {
              icon : 'times-circle',
              className: "error-class",
            });
            return;
      }
      if(this.selected_validation == null){
        this.$toasted.show('Please select a validation!', {
              icon : 'times-circle',
              className: "error-class",
            });
            return;
      }
    
      
      if(this.quantity<1 || this.isInt(this.quantity)==false){
            
           this.$toasted.show('Please enter a valid quantity !', {
              icon : 'times-circle',
              className: "error-class",
            });
            return;
      }

      this.create_button.loading = true;
      this.create_button.disabled = true;
      this.create_button.success = false;

      this.management_list_refresh_status = false;
      this.axios
        .post(window.hostname + "/api/auth/validation/save_validation",
        {
          selected_validation:  this.selected_validation,
          selected_department:  this.selected_department,
          quantity:             this.quantity,
        })
        .then((res) => {
         
          this.create_button.disabled = false;
          this.create_button.success = true;
          this.create_button.loading = false;
          this.management_list_refresh_status = true;
          //this.$emit('update_validation_management_list');
          this.closeModal();
          this.$toasted.show('Validation saved successfully !', {
               icon: "check-circle",
              className: "success-class",
            });
        })
        .catch((err) => {
          this.create_button.disabled = false;
          this.create_button.success = false;
          this.create_button.loading = false;
          this.$toasted.show('Something went wrong. Please try again !', {
              icon : 'times-circle',
              className: "error-class",
            });
        });
    },
  },
};
</script>

<style scoped>
.modified-toggle-switch p {
  flex-basis: 50%;
}

.modified-toggle-switch app-toggle {
  flex-basis: 50%;
}
input[type="text"] {
  background: transparent;
  outline: none;
  border-radius: 22px;
  border: 1px solid #535353;
}
.quantity {
  color: #848484;
  font-size: 10px;
}
</style>